















































import {
  defineComponent,
  onMounted,
  ref,
  toRefs,
  onBeforeUnmount
} from '@nuxtjs/composition-api'

import { Timeout } from '~/models/timing/timeout'
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import { useSwipe } from '~/compositions/swipe'

export default defineComponent({
  props: {
    interval: {
      type: Number,
      required: false,
      default: 0
    },
    hideArrows: {
      type: Boolean,
      required: false,
      default: false
    },
    arrowsOnHover: {
      type: Boolean,
      required: false,
      default: true
    },
    btnVariant: {
      type: String,
      default: 'black',
      required: false
    },
    showDots: {
      type: Boolean,
      required: false,
      default: true
    },
    sliderClass: {
      type: String,
      required: false,
      default: ''
    },
    indexSliderClass: {
      type: String,
      default: ''
    },
    slotsCount: {
      type: Number,
      required: true
    },
    swipeEnabled: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    const { interval, slotsCount, swipeEnabled } = toRefs(props)
    const slideInterval = ref<Timeout | null>(null)
    const transitionName = ref('swipe-left')
    const activeSlide = ref(0)

    // const getSlots = () => {
    // console.log('slots is', _slots.default())
    // _slots.default().map((node, index) => {
    //   node.key = `slot-${index}`
    //   return node
    // })
    // console.log('affter is', _slots.default())
    // if (slider?.value?.$slots) {
    //   const childNodes = Array.from(slider?.value?.$slots.default)
    //   mySlots.value = childNodes.filter((n: any) => Boolean(n?.elm))
    // } else {
    //   mySlots.value = ['a', 'b']
    // }
    // }

    const swipeableElement = ref<HTMLElement | null>(null)

    onMounted(() => {
      setAutoSlideInterval()
    })

    onBeforeUnmount(() => {
      clearInterval(slideInterval.value)
    })

    const setAutoSlideInterval = () => {
      if (interval.value) {
        clearInterval(slideInterval.value)
        if (slotsCount.value > 1) {
          slideInterval.value = setInterval(nextSlide, interval.value)
        }
      }
    }
    const prevSlide = () => {
      transitionName.value = 'swipe-right'
      if (activeSlide.value > 0) {
        activeSlide.value--
      } else {
        activeSlide.value = slotsCount.value - 1
      }
      setAutoSlideInterval()
    }

    const nextSlide = () => {
      transitionName.value = 'swipe-left'
      if (activeSlide.value < slotsCount.value - 1) {
        activeSlide.value++
      } else {
        activeSlide.value = 0
      }
      setAutoSlideInterval()
    }

    const { getDragging } = useSwipe(
      swipeableElement,
      nextSlide,
      prevSlide,
      swipeEnabled.value
    )

    const onDotClick = (slideToActivate: number) => {
      if (slideToActivate !== activeSlide.value) {
        transitionName.value =
          slideToActivate < activeSlide.value ? 'swipe-right' : 'swipe-left'
        activeSlide.value = slideToActivate
        setAutoSlideInterval()
      }
    }

    const isDragging = () => {
      return getDragging()
    }

    return {
      swipeableElement,
      transitionName,
      prevSlide,
      nextSlide,
      onDotClick,
      setAutoSlideInterval,
      activeSlide,
      faChevronLeft,
      faChevronRight,
      isDragging
    }
  }
})
